import { LoadingButton } from "@mui/lab"
import { Button, Stack } from "@mui/material"
import * as React from "react"
import type { Icon as FeatherIcon } from "react-feather"
import { PageHeader, type PageHeaderProps } from "../../../layout"
import { ActionButtonTrigger } from "../../../navigation"

interface BaseHeaderAction {
  icon: FeatherIcon
  label: string
  disabled?: boolean
  hidden?: boolean
}
type ClickHeaderAction = { onClick: () => void } & BaseHeaderAction
type LinkHeaderAction = { to: string } & BaseHeaderAction
export type HeaderAction = ClickHeaderAction | LinkHeaderAction

const getActionsElements = (actions: HeaderAction[]) => {
  const visibleActions = actions.filter((action) => !action.hidden)

  if (visibleActions.length === 0) return null
  return (
    <ActionButtonTrigger
      items={visibleActions.map((action) => ({
        ...("to" in action
          ? {
              to: action.to,
            }
          : {
              onClick: action.onClick,
            }),
        Icon: action.icon,
        label: action.label,
        disabled: action.disabled,
      }))}
    />
  )
}

export type FormHeaderProps = Pick<PageHeaderProps, "title" | "level" | "chip"> & {
  onCancel?: () => void
  submitLabel?: string
  submitLoading?: boolean
  onSubmit?: () => void
  otherActions?: HeaderAction[]
}

/**
 * Ensure consistent styles / business rules across forms
 */
export const FormHeader = ({
  title,
  level = 2,
  onCancel,
  submitLabel = "Enregistrer",
  submitLoading = false,
  onSubmit,
  otherActions = [],
  chip,
}: FormHeaderProps) => {
  const actions = React.useMemo(
    () => getActionsElements(otherActions),
    [otherActions],
  )

  return (
    <PageHeader title={title} level={level} chip={chip}>
      <Stack direction="row" alignItems="center" spacing={1}>
        {!!onCancel && <Button onClick={onCancel}>Annuler</Button>}
        {!!onSubmit && (
          <LoadingButton
            variant="contained"
            onClick={onSubmit}
            loading={submitLoading}
          >
            {submitLabel}
          </LoadingButton>
        )}
        {actions}
      </Stack>
    </PageHeader>
  )
}
